import { useTranslation } from "react-i18next";
import type { Turn } from "../../util/slopifyThread";
import { isPropagationProposal } from "../../util/slopifyThread";
import LanguageSubCard from "./LanguageSubCard";

interface PropagationCardProps {
  turn: Turn;
  sourceValues: Record<string, unknown>;
  onApplyLanguage: (turnId: string, languageId: number) => void;
  onRejectLanguage: (turnId: string, languageId: number) => void;
  onApplyAll: (turnId: string) => void;
}

export const PropagationCard = ({
  turn,
  sourceValues,
  onApplyLanguage,
  onRejectLanguage,
  onApplyAll,
}: PropagationCardProps) => {
  const { t } = useTranslation();
  if (!isPropagationProposal(turn.proposal)) return null;
  const { languages, fieldNames } = turn.proposal;
  const pendingCount = languages.filter((l) => l.status === "pending").length;

  return (
    <div className="rounded-md border border-green-200 bg-white shadow-sm p-2 mb-2 slopify-slide-in">
      <div className="flex items-center gap-2">
        <span className="text-[11px] font-medium text-green-700">
          {t("general.assistantScenarIa.propagation.header", {
            count: languages.length,
          })}
        </span>
        <button
          type="button"
          className="ml-auto text-[11px] px-2 py-1 rounded-md bg-green-500 text-white hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={pendingCount === 0}
          onClick={() => onApplyAll(turn.id)}
        >
          {t("general.assistantScenarIa.propagation.applyAll")}
        </button>
      </div>

      <div className="mt-2">
        {languages.map((lang) => (
          <LanguageSubCard
            key={lang.languageId}
            language={lang}
            fieldNames={fieldNames}
            sourceValues={sourceValues}
            onApply={(lid) => onApplyLanguage(turn.id, lid)}
            onReject={(lid) => onRejectLanguage(turn.id, lid)}
          />
        ))}
      </div>
    </div>
  );
};

export default PropagationCard;
